const { render, useState } = wp.element;
import React, { Component } from "react";
import { withTranslation } from "react-i18next";
import { connect } from "react-redux";
import CustomReactValidator from "../CustomReactValidator";

import "date-fns";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFnsV3";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";

//Action to save and fetch data
import { UserRegister } from "../../actions/front_actions";

//Import Designs
import {
    Typography,
    Grid2,
    FormControl,
    TextField,
    TextareaAutosize,
    FormControlLabel,
    Checkbox,
    RadioGroup,
    Radio,
    Select,
    MenuItem,
    Button,
} from "@mui/material";
import ReactHtmlParser from "react-html-parser";
import ReCAPTCHA from "react-google-recaptcha";

class Register extends Component {
    constructor(props) {
        super(props);
        this.state = { wait: 0, recaptcha: null, login_error: false };
        const { t } = this.props;
        this.validator = new CustomReactValidator({
            messages: {
                in: t("password_match_validation"),
                email: t("email_validation"),
                alpha_num_dash_space: t("alpha_num_dash_space_validation"),
            },
        });
    }

    submitForm = () => {
        if (this.validator.allValid()) {
            const inputdata = this.state;
            this.props.UserRegister(this.props.SITE_URL, inputdata);
        } else {
            this.validator.showMessages();
            this.forceUpdate();
        }
    };

    componentWillReceiveProps(nextProps) {
        if (typeof nextProps.user_registration !== "undefined") {
            if (typeof nextProps.user_registration.error !== "undefined") {
                this.setState({ login_error: true });
            } else if (!nextProps.auto_login) {
                const { t } = this.props;
                alert(t("registration_successfull"));
                window.location.reload();
            } else {
                let user_id = nextProps.user_registration.ID;
                if (typeof user_id !== "undefined") {
                    window.location.reload();
                }
            }
        }
    }

    handleValueChange = (externalId) => (event) => {
        this.setState({ [event.target.name]: event.target.value });
    };

    handleValueDate = (externalId) => (event) => {
        const value = event;
        this.setState({ [externalId]: value });
    };

    handleValuecheckbox = (externalId) => (event, isChecked) => {
        let name = event.target.name;
        let get_previous_val =
            typeof this.state[name] !== "undefined" ? this.state[name] : "";
        if (isChecked) {
            if (get_previous_val == "") {
                this.setState({ [event.target.name]: event.target.value });
            } else {
                let add_val = get_previous_val + "," + event.target.value;
                this.setState({ [event.target.name]: add_val });
            }
        } else {
            if (get_previous_val != "") {
                let new_string = get_previous_val.replace(
                    "," + event.target.value,
                    ""
                );
                let new_string_val = new_string.replace(
                    event.target.value + ",",
                    ""
                );
                let new_string_vl = new_string_val.replace(
                    event.target.value,
                    ""
                );
                this.setState({ [event.target.name]: new_string_vl });
            }
        }
    };

    onCaptchaClick = (value) => {
        this.setState({ recaptcha: value });
    };

    render() {
        const { t, i18n } = this.props;
        const { vote_enable_recaptcha, vote_recapatcha_key, vote_auto_login } =
            this.props.settings.common;

        const register_form =
            typeof this.props.register_form !== "undefined"
                ? this.props.register_form
                : [];
        let error_login = null;
        if (typeof this.props.user_registration !== "undefined") {
            if (typeof this.props.user_registration.error !== "undefined") {
                error_login = this.props.user_registration.error;
            }
        }
        let shortcode_check = this.props.shortcode;
        let style_item = 12;
        if (shortcode_check == "login") {
            style_item = 6;
        }
        return (
            <Grid2
                container
                className="wpvc_register_page"
                direction="row"
                columnSpacing={2}
                rowSpacing={2}
            >
                <Grid2
                    className="wpvc_register_page_item"
                    size={{
                        xs: 12,
                        sm: style_item,
                    }}
                >
                    <FormControl fullWidth className="wpvc_form_control">
                        <TextField
                            className="wpvc_text_field"
                            type="text"
                            name="username"
                            label={t("login_username")}
                            onChange={this.handleValueChange()}
                            autoComplete="username"
                            variant="standard"
                        />
                    </FormControl>
                    {this.validator.message(
                        t("username_required"),
                        this.state.username,
                        "required"
                    )}
                </Grid2>
                <Grid2
                    className="wpvc_register_page_item"
                    size={{
                        xs: 12,
                        sm: style_item,
                    }}
                >
                    <FormControl fullWidth className="wpvc_form_control">
                        <TextField
                            className="wpvc_text_field"
                            type="text"
                            name="email"
                            label={t("login_email")}
                            onChange={this.handleValueChange()}
                            autoComplete="username"
                            variant="standard"
                        />
                    </FormControl>
                    {this.validator.message(
                        t("voter_email_required"),
                        this.state.email,
                        "required|email"
                    )}
                </Grid2>
                <Grid2
                    className="wpvc_register_page_item"
                    size={{
                        xs: 12,
                        sm: style_item,
                    }}
                >
                    <FormControl fullWidth className="wpvc_form_control">
                        <TextField
                            className="wpvc_text_field"
                            type="password"
                            name="password"
                            label={t("login_password")}
                            onChange={this.handleValueChange()}
                            autoComplete="new-password"
                            variant="standard"
                        />
                        {this.validator.message(
                            t("password_required"),
                            this.state.password,
                            "required"
                        )}
                    </FormControl>
                </Grid2>
                <Grid2
                    className="wpvc_register_page_item"
                    size={{
                        xs: 12,
                        sm: style_item,
                    }}
                >
                    <FormControl fullWidth className="wpvc_form_control">
                        <TextField
                            className="wpvc_text_field"
                            type="password"
                            name="confirmpassword"
                            label={t("login_cpassword")}
                            onChange={this.handleValueChange()}
                            autoComplete="new-password"
                            variant="standard"
                        />
                        {this.validator.message(
                            t("confirm_password_required"),
                            this.state.confirmpassword,
                            "required|in:" + this.state.password
                        )}
                    </FormControl>
                </Grid2>
                {register_form.map((item, index) => (
                    <Grid2
                        key={index}
                        className="wpvc_register_page_item"
                        size={{
                            xs: 12,
                            sm: style_item,
                        }}
                    >
                        {(item.question_type == "SINGLE" ||
                            item.question_type == "DATE" ||
                            item.question_type == "DROPDOWN" ||
                            item.question_type == "MULTIPLE" ||
                            item.question_type == "TEXTAREA") && (
                            <Grid2
                                className="wpvc_form_control_label"
                                size={12}
                            >
                                <Typography>{item.question}</Typography>
                            </Grid2>
                        )}
                        {item.question_type == "TEXT" && (
                            <FormControl
                                fullWidth
                                className="wpvc_form_control"
                            >
                                <TextField
                                    className="wpvc_text_field"
                                    type={item.react_values.text_field_type}
                                    name={item.system_name}
                                    label={item.question}
                                    value={this.state[item.system_name] || ""}
                                    onChange={this.handleValueChange()}
                                    variant="standard"
                                />
                                {item.required == "Y" &&
                                    this.validator.message(
                                        item.required_text != null &&
                                            item.required_text != ""
                                            ? item.required_text
                                            : t("enter_the") + item.question,
                                        this.state[item.system_name],
                                        "required"
                                    )}
                            </FormControl>
                        )}
                        {item.question_type == "TEXTAREA" && (
                            <FormControl
                                fullWidth
                                className="wpvc_form_control"
                            >
                                <TextareaAutosize
                                    name={item.system_name}
                                    minRows={
                                        item.react_values.text_area_row || 2
                                    }
                                    placeholder={item.question}
                                    value={this.state[item.system_name] || ""}
                                    onChange={this.handleValueChange()}
                                    style={{ maxWidth: "100%", width: "100%" }}
                                />

                                {item.required == "Y" &&
                                    this.validator.message(
                                        item.required_text != null &&
                                            item.required_text != ""
                                            ? item.required_text
                                            : t("enter_the") + item.question,
                                        this.state[item.system_name],
                                        "required|alpha_num_dash_space"
                                    )}
                            </FormControl>
                        )}
                        {item.question_type == "SINGLE" && (
                            <FormControl
                                fullWidth
                                className="wpvc_form_control_single"
                                component="fieldset"
                            >
                                <RadioGroup
                                    row
                                    aria-label="vote_votingtype"
                                    name={item.system_name}
                                    onChange={this.handleValueChange()}
                                >
                                    {Object.keys(item.drop_values).map(
                                        (key) => (
                                            <FormControlLabel
                                                key={key}
                                                className="wpvc_submit_label"
                                                control={
                                                    <Radio color="primary" />
                                                }
                                                value={item.drop_values[key]}
                                                label={item.drop_values[key]}
                                                labelPlacement={item.react_values.value_placement?.toLowerCase()}
                                            />
                                        )
                                    )}
                                </RadioGroup>
                                {item.required == "Y" &&
                                    this.validator.message(
                                        item.required_text != null &&
                                            item.required_text != ""
                                            ? item.required_text
                                            : t("enter_the") + item.question,
                                        this.state[item.system_name],
                                        "required"
                                    )}
                            </FormControl>
                        )}
                        {item.question_type == "DROPDOWN" && (
                            <FormControl
                                fullWidth
                                className="wpvc_form_control_single"
                            >
                                <Select
                                    variant="standard"
                                    name={item.system_name}
                                    defaultValue={""}
                                    className="wpvc_submit_select"
                                    onChange={this.handleValueChange()}
                                >
                                    {Object.keys(item.drop_values).map(
                                        (key) => (
                                            <MenuItem
                                                key={key}
                                                value={item.drop_values[key]}
                                            >
                                                {item.drop_values[key]}
                                            </MenuItem>
                                        )
                                    )}
                                </Select>
                                {item.required == "Y" &&
                                    this.validator.message(
                                        item.required_text != null &&
                                            item.required_text != ""
                                            ? item.required_text
                                            : t("enter_the") + item.question,
                                        this.state[item.system_name],
                                        "required"
                                    )}
                            </FormControl>
                        )}

                        {item.question_type == "MULTIPLE" && (
                            <FormControl
                                component="fieldset"
                                fullWidth
                                className="wpvc_form_control_single"
                            >
                                <RadioGroup row aria-label="vote_votingtype">
                                    {Object.keys(item.drop_values).map(
                                        (key) => (
                                            <FormControlLabel
                                                key={key}
                                                className="wpvc_submit_label"
                                                control={
                                                    <Checkbox
                                                        color="primary"
                                                        name={item.system_name}
                                                        onChange={this.handleValuecheckbox()}
                                                    />
                                                }
                                                value={item.drop_values[key]}
                                                label={item.drop_values[key]}
                                                labelPlacement={item.react_values.value_placement?.toLowerCase()}
                                            />
                                        )
                                    )}
                                </RadioGroup>
                                {item.required == "Y" &&
                                    this.validator.message(
                                        item.required_text != null &&
                                            item.required_text != ""
                                            ? item.required_text
                                            : t("enter_the") + item.question,
                                        this.state[item.system_name],
                                        "required"
                                    )}
                            </FormControl>
                        )}

                        {item.question_type == "DATE" && (
                            <FormControl
                                component="fieldset"
                                fullWidth
                                className="wpvc_form_datepicker"
                            >
                                <LocalizationProvider
                                    dateAdapter={AdapterDateFns}
                                >
                                    <DatePicker
                                        className="wpvc_datepicker"
                                        value={
                                            this.state[item.system_name]
                                                ? this.state[item.system_name]
                                                : new Date()
                                        }
                                        onChange={this.handleValueDate(
                                            item.system_name
                                        )}
                                        format={
                                            item.react_values.datepicker_only
                                        }
                                    />
                                </LocalizationProvider>
                                {item.required == "Y" &&
                                    this.validator.message(
                                        item.required_text != null &&
                                            item.required_text != ""
                                            ? item.required_text
                                            : t("enter_the") + item.question,
                                        this.state[item.system_name],
                                        "required"
                                    )}
                            </FormControl>
                        )}
                    </Grid2>
                ))}
                {vote_enable_recaptcha == "on" && vote_recapatcha_key != "" && (
                    <ReCAPTCHA
                        sitekey={vote_recapatcha_key}
                        onChange={this.onCaptchaClick}
                    />
                )}
                {vote_enable_recaptcha == "on" &&
                    this.validator.message(
                        t("verify_captcha"),
                        this.state.recaptcha,
                        "required"
                    )}
                <Grid2 container size={12} justifyContent="flex-start">
                    <Typography className="wpvc_error_login">
                        {ReactHtmlParser(error_login)}
                    </Typography>
                    <Button
                        variant="contained"
                        className="wpvc_login_btns"
                        color="secondary"
                        onClick={this.submitForm}
                    >
                        {t("create_myaccount")}
                    </Button>
                </Grid2>
                <Grid2 container size={12} justifyContent="flex-start">
                    <Button
                        className="wpvc_forgot_link"
                        color="primary"
                        component="a"
                        onClick={() => {
                            this.props.handleaccount();
                        }}
                    >
                        {t("already_have_account")}
                    </Button>
                </Grid2>
            </Grid2>
        );
    }
}

const settingstate = (state) => {
    return { login: state.wpvcfrontdata };
};

export default connect(settingstate, { UserRegister })(
    withTranslation("translations")(Register)
);
